import React, { useEffect, useMemo } from "react";

import RpMuiAutocompleteSelect from "@/components/muiCustom/select/RpMuiAutocompleteSelect";
import type { RRDAsset, RRDAssetGroups } from "./rrdTemplateTypes";

function RRDDirectMailAssetFilter({
  assets,
  onSelectLabel,
  disablePortal = false,
}: {
  assets?: RRDAssetGroups;
  onSelectLabel: (_value: unknown[]) => void;
  disablePortal?: boolean;
}) {
  const [value, setValue] = React.useState<unknown[]>([]);

  useEffect(() => {
    onSelectLabel(value);
  }, [value]);

  const labels = useMemo(() => {
    let labels: string[] = [];

    const collectLabels = (acc: string[], asset: RRDAsset) => {
      const { labels = [] } = asset;
      labels && acc.push(...labels);
      return acc;
    };

    const heroLabels = assets?.heroImages?.reduce(collectLabels, []);

    const largeHeroLabels = assets?.largeHeroImages?.reduce(collectLabels, []);

    const mediumHeroLabels = assets?.mediumHeroImages?.reduce(
      collectLabels,
      []
    );

    const couponLabels = assets?.coupons?.reduce(collectLabels, []);

    if (heroLabels?.length) labels = [...labels, ...heroLabels];
    if (largeHeroLabels?.length) labels = [...labels, ...largeHeroLabels];
    if (mediumHeroLabels?.length) labels = [...labels, ...mediumHeroLabels];
    if (couponLabels?.length) labels = [...labels, ...couponLabels];

    return [...new Set(labels)];
  }, [assets]);

  const options = useMemo(() => {
    return labels.map((label) => ({
      label,
      value: label,
    }));
  }, [labels]);

  return (
    <div>
      <RpMuiAutocompleteSelect
        options={options}
        multiple
        withCheckbox
        withApplyButton
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        disablePortal={disablePortal}
        wrapperProps={{
          className: "",
          sx: {
            padding: "0 !important",
          },
        }}
      />
    </div>
  );
}

export default RRDDirectMailAssetFilter;
